import { accountInitialValue } from "@/types/app/accounts";

export default {  
  selectProducts: [],
  selectFunds: []
};
